// Generated by ReScript, PLEASE EDIT WITH CARE


let storageKey = "cnx-theme";

let readStored = (function(key) {
    try { return localStorage.getItem(key); }
    catch (e) { return null; }
  });

let writeStored = (function(key, theme) {
    try { localStorage.setItem(key, theme); }
    catch (e) {}
  });

let setDataTheme = (function(theme) {
    document.documentElement.setAttribute("data-theme", theme);
  });

function toValue(theme) {
  if (theme === "light") {
    return "light";
  } else {
    return "dark";
  }
}

function apply(theme) {
  let value = toValue(theme);
  setDataTheme(value);
  writeStored(storageKey, value);
}

function fromValue(value) {
  if (value === "light") {
    return "light";
  } else {
    return "dark";
  }
}

function initial() {
  let value = readStored(storageKey);
  if (value == null) {
    return "dark";
  } else {
    return fromValue(value);
  }
}

function toggle(theme) {
  if (theme === "light") {
    return "dark";
  } else {
    return "light";
  }
}

export {
  storageKey,
  readStored,
  writeStored,
  setDataTheme,
  toValue,
  apply,
  fromValue,
  initial,
  toggle,
}
/* No side effect */
